import { decryptData, encryptData } from "utils/dataCipherHelper";
import { instance as axios, setHeaders } from "../config/axiosInstance";

// User Details API
export const userDetailsApi = async (data) => {
  const responseData = await axios.get(
    `profile/detail?reqData=${encryptData(data)}`,
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// User Logout API
export const userLogoutApi = async (data) => {
  const responseData = await axios.put(
    "profile/logout-user",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// User Change Password Api
export const userChangePasswordAPi = async (data) => {
  const responseData = await axios.put(
    "profile/change-password",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// User User Profile Api
export const updateUserProfile = async (data) => {
  const responseData = await axios.put(
    "profile/update-profile",
    {
      reqData: encryptData(data),
    },
    setHeaders()
  );
  return decryptData(responseData?.data || "");
};

// User User Profile Pic Api
export const updateUserPicApi = async (data,imageFile) => {
  const formData = new FormData()
  formData.append("reqData",encryptData(data))
  formData.append("profile",imageFile)
  const responseData = await axios.put("profile/update-image", formData,setHeaders("multipart"));
  return decryptData(responseData?.data || "");
};
